import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  transformDictionaryAll: [],
  transformDictionary: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const transformDictionarySlice = createSlice({
  name: "transformDictionary",
  initialState,
  reducers: {
    settransformDictionaryAll: (state, action) => {
      state.transformDictionaryAll = action.payload;
    },
    settransformDictionary: (state, action) => {
      state.transformDictionary = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  settransformDictionaryAll,
  settransformDictionary,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = transformDictionarySlice.actions;

export default transformDictionarySlice.reducer;
